import {BaseRepository} from '~/repositories/BaseRepository';
import {CookieHelper} from '~/utils/CookieHelper';
import {_get} from '~/utils/lodash';
import {PermissionAction, PermissionPrefix, PermissionType} from '~/repositories/types';
import {IMeState} from '~/store/types';
import PermissionHelper from '~/utils/PermissionHelper';
import {CustomerDatabaseFormPermissionOption} from '~/features/marketing/permission/types';
import {Core} from "~/core/Core"
import {LocalStorageHelper} from '~/utils/LocalStorageHelper'
import { ObjectLoader } from '~/loader/object';
import { API_TYPE } from '~/constants/apiTypes';
import { IContext } from 'pam4-tracker';
import {IAuth} from "~/features/user/types";
import { TimeHelper } from "~/utils/TimeHelper";
import { SeamanHTTP } from "~/http/SeamanHTTP";
import {ILoaderOption, IFetchOption} from '~/loader/types'

export default class AuthRepository extends BaseRepository {
  get seaman(): SeamanHTTP {
    return new SeamanHTTP();
  }

  get isAuth(): boolean {
    return _get(this.state, 'app.me.token', false)
  }

  get isNotAuth(): boolean {
    return !this.isAuth
  }

  get me(): IMeState | null {
    return this.state?.app?.me || null
  }

  get sidebarPermission(): string[] {
    let perms: string[] = []
    for (const [key,] of Object.entries(this.me?.permissions || {})) {
      const length = key.split('_').length
      if (length === 4) {
        perms = [
          ...perms,
          key
        ]
      }
    }
    return perms
  }

  get customerDatabasePermission(): string[] {
    let perms: string[] = []
    for (const [key,] of Object.entries(this.me?.permissions || {})) {
      const length = key.split('_').length
      if (length === 5) {
        perms = [
          ...perms,
          key
        ]
      }
    }
    return perms
  }

  logout(_vm: IContext | any, isNoRedirecttoLogin: boolean) {
    const logoutLoader = new ObjectLoader(_vm, (data: any) => ({
      apiType: API_TYPE.ECOM,
      baseURL: Core.config.AUTHENTICATION_PATH == "ecom"
        ? Core.ECOMCMSAPI("/logout")
        : Core.MKTBACKENDAPI("/logout"),

      onAddSuccess: (newValue) => {
      },
    }))
    
    logoutLoader.$add({})
    CookieHelper.remove('me')
    LocalStorageHelper.set('me', null)

    this.commit('app/replaceState', {key: 'me', data: null});

    if (!isNoRedirecttoLogin) {
      this.router.push({
        path: '/login',
        query: {
          ...this.route.query,
          redirect: this.route.path,
        }
      })
    }
  }

  get hasGrantAll(): boolean {
    for (const [key, value] of Object.entries(this.me?.permissions || {})) {
      if (key === 'grant_all' && value) {
        return true
      }
    }

    return false
  }

  hasPermission(key: string, prefix: PermissionPrefix, type?: PermissionType, action?: PermissionAction): boolean {
    if (prefix === PermissionPrefix.CUSTOMER_DATABASE) {

    } else if (prefix === PermissionPrefix.SIDEBAR_PERMISSION) {
      // key in sidebar context mean menu
      const [feature, menu] = PermissionHelper.getSidebarKeys('')
      // PermissionHelper.getSidebarKeys(key)
    }

    return false
  }

  isHideField(key?: string): boolean {
    if (!key) {
      return true
    }
    return !this.canViewField(key) && !this.canEditField(key)
  }

  canViewField(key?: string): boolean {
    if (!key) {
      return true
    }
    const [view, edit] = this.isHasPermission(key)
    return (view || edit) || this.hasGrantAll
  }

  canEditField(key?: string): boolean {
    if (!key) {
      return true
    }
    const [, edit] = this.isHasPermission(key)
    return edit || this.hasGrantAll
  }

  isHasPermission(key: string): [boolean, boolean] /* [view,edit] */ {
    let canView = false
    let canEdit = false

    for (let i = 0; i < this.customerDatabasePermission.length; i++) {
      const perm = this.customerDatabasePermission[i]
      const keys = perm.split('_')
      const attribute = keys[3]
      const action = keys[4]

      if (attribute === key) {
        if (action === CustomerDatabaseFormPermissionOption.VIEW) {
          canView = true
        } else if (action === CustomerDatabaseFormPermissionOption.EDIT) {
          canEdit = true
        }
      }
    }

    return [canView, canEdit]
  }

  loginAD = async (
    _vm: IContext | any,
    data: any
  ): Promise<IAuth> => {
    const headers: { [key: string]: any } = {
      "x-timestamp": TimeHelper.toUTC(TimeHelper.getCurrentDateTime()),
      "x-device": "browser",
    };

    

    const response = await this.seaman.postAndResolveRef(
      Core.MKTBACKENDAPI("/login-by-ad-token"),
      data ?? {},
      headers
    )

    if (response.error) {
      // throw new ResponseError(response.errorCode, response.errorMessage);
    }
    else {
      // this.commit('app/replaceState', {key: 'me', data: null});
      _vm.$app.replaceState("me", response.data)
      // LocalStorageHelper.set("me", response.data);

      CookieHelper.setAzureADMeToken(response.data?.token || null)
    }

    return response.data;
  }

  async loginADTokenLoader(_vm: IContext | any,  adToken: string, appID: string) {
    const loginLoader = new ObjectLoader(
      _vm,
      (data?: any): ILoaderOption => ({
        apiType: "MKT",
        baseURL: Core.MKTBACKENDAPI(`/login-by-ad-token`),
        stateKey: "me",

        onAddSuccess: (newValue) => {
          this.commit('app/replaceState', {key: 'me', data: loginLoader.addItem});
          LocalStorageHelper.set("me", loginLoader.addItem);
          CookieHelper.setAzureADMeToken(loginLoader.addItem.token || null);
          if (Core.config.ENABLED_SKIP_PAGE_PLATFORM_SELECTION) {
              _vm.$router.push({
                path: "/marketing"
              })
          }
        },

        onAddError: (newValue) => {
        },
      })
    );

    await loginLoader.$add(
      {
        app_id: appID,
        ad_token: adToken,
      }
    );
  }

  get enabledFeatureLoginADToken() {
    let isEnableFeature = Core.config.ENABLED_FEATURE_LOGIN_AD_TOKEN;
    return isEnableFeature;
  }

  
}
